import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './api.slice';
import authReducer from './auth/auth.slice';
import homeReducer from './home/home.slice';
import breadcrumbReducer from './breadcrumb/breadcrumb.slice';
import { dealRetailerApi } from './deal-retailer/deal-retailer.api';

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    home: homeReducer,
    dealRetailer: dealRetailerApi.reducer,
    breadcrumb: breadcrumbReducer
  },
  devTools: process.env.NODE_ENV !== 'production',
  // devTools: true,
  middleware: (getDefaultMiddlewares: any) =>
    getDefaultMiddlewares().concat(apiSlice.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
